<template>
  <div class="main">
    <!-- <head-com></head-com> -->
    企业后台
  </div>
</template>

<script>
// import HeadCom from "@/components/Header.vue";

export default {
  name: "manage",
  components: {
    // HeadCom
  }
};
</script>
<style lang="less" scoped></style>
